"use client";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import UnitIcon from "@/components-shared/unit-icon";
import { unitTypes } from "@/lib/enums";

export type PropMarkerProps = {
  prop: Property;
  onClick: (prop: Property) => void;
};

export const PropMarker = (props: PropMarkerProps) => {
  const { prop } = props;

  const handleClick = () => {
    props?.onClick(prop);
  };

  return (
    <AdvancedMarker
      position={{ lat: prop.location.lat, lng: prop.location.lng }}
      onClick={handleClick}
      clickable
    >
      <div className="flex justify-between gap-2 items-center bg-white border-2 border-black rounded-full py-2 px-3 ">
        <UnitIcon
          className="stroke-green-main size-4"
          type={prop.classification as unitTypes}
        />
        <span>{prop.totalPrice} ر.س</span>
      </div>
    </AdvancedMarker>
  );
};
